import * as React from 'react';
const IconCross = ({ color = 'white' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    style={{ width: '21px', height: '21px' }}
  >
    <path d="M2.86255 18.1797L18.0422 3.00002" stroke={color} strokeWidth={5.45} strokeLinecap="round" />
    <path d="M2.87354 3L18.0532 18.1797" stroke={color} strokeWidth={5.45} strokeLinecap="round" />
  </svg>
);
export default IconCross;
